import React, { useEffect } from 'react';
import WorkflowNotificationNode from './WorkflowNotificationNode';

const HOVER_TEXT = `
Users added to this step will receive a push notification
in the Ontraccr mobile app.
`;

const AUTHOR_HELP = 'An push notification will be sent to the form\'s author';

export default ({
  setElements,
  setDataMap,
  isDisplay,
  divisionId,
  divisionIds = [],
  sections = [],
  isExternalForm,
  setDisableNext,
} = {}) => ({
  id,
  draggable,
  data,
}) => {

  useEffect(() => {
    if (!setDisableNext) return;
    setDisableNext((prev) => ({ ...prev, [id]: true }));
  }, [id, setDisableNext]);

  return (
    <WorkflowNotificationNode
      type='push'
      id={id}
      draggable={draggable}
      data={data}
      onNodeUpdate={(...args) => {
        setElements(...args);
        if (setDisableNext) {
          setDisableNext((prev) => ({ ...prev, [id]: false }));
        }
      }}
      setDataMap={setDataMap}
      isDisplay={isDisplay}
      hover={HOVER_TEXT}
      divisionId={divisionId}
      divisionIds={divisionIds}
      showFormAuthor
      formAuthorHelperText={AUTHOR_HELP}
      sections={sections}
      isExternalForm={isExternalForm}
      setDisableNext={setDisableNext}
    />
  )
}